/** @format */

import { request } from 'src/utils'

// eslint-disable-next-line import/no-anonymous-default-export
export const API = {
  getAlarmShields: '/monitor/?Action=DescribeAlarmShields&Version=2024-01-01',
  modifyShields: '/monitor/?Action=ModifyAlarmShield&Version=2024-01-01',
  deleteShields: '/monitor/?Action=DeleteAlarmShield&Version=2024-01-01',
  createShields: '/monitor/?Action=CreateAlarmShield&Version=2024-01-01',
  enableShields: '/monitor/?Action=EnableAlarmShield&Version=2024-01-01',
  disabledShields: '/monitor/?Action=DisableAlarmShield&Version=2024-01-01',
  getShieldsInstances: '/monitor/?Action=DescribeAlarmShieldResources&Version=2024-01-01'
}

// 获取
export const getAlarmShields = async (params: any) => {
  const result = await request(API.getAlarmShields, {
    method: 'GET',
    data: { ProductType: 999, ...params }
  })
  return result?.data || {}
}

// 编辑
export const modifyShields = async (params: any) => {
  const result = await request(API.modifyShields, {
    method: 'POST',
    data: { ...params }
  })
  return result?.code === 'Success'
}

// 删除
export const deleteShields = async id => {
  const result = await request(API.deleteShields, {
    method: 'POST',
    data: { ShieldID: id }
  })
  return result?.code === 'Success'
}

// 创建
export const createShields = async params => {
  const result = await request(API.createShields, {
    method: 'POST',
    data: params
  })
  return result?.code === 'Success'
}

// 启用/禁用
export const enableShields = async (enable, id) => {
  const result = await request(enable === 2 ? API.enableShields : API.disabledShields, {
    method: 'POST',
    data: { ShieldID: id }
  })
  return result?.code === 'Success'
}
export default API

// 获取屏蔽规则下的资源
export const getShieldsInstances = async (id: any) => {
  const result = await request(API.getShieldsInstances, {
    method: 'GET',
    data: { ShieldID: id, PageSize: 9999 }
  })
  return result?.data || {}
}
